// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3_XEk","content":"RecentSearches_content__YOFWc"};